export default "<div class=\"chart-container\">\r\n    <canvas  id=\"genderChart\">{{ chart }}</canvas>\r\n</div>";